module.exports = __webpack_public_path__ + "img/snowflake.e7ffc922.svg";